import { render, staticRenderFns } from "./create-group-document.vue?vue&type=template&id=278c9f5c&scoped=true&"
import script from "./create-group-document.vue?vue&type=script&lang=js&"
export * from "./create-group-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c9f5c",
  null
  
)

export default component.exports